// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApprovalController from "./approval_controller"
application.register("approval", ApprovalController)

import CredentialFieldController from "./credential_field_controller"
application.register("credential-field", CredentialFieldController)

import CredentialFormController from "./credential_form_controller"
application.register("credential-form", CredentialFormController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SimulationFormController from "./simulation_form_controller"
application.register("simulation-form", SimulationFormController)

import AnnouncementBannerController from "./announcement_banner_controller"
application.register("announcement-banner", AnnouncementBannerController)

import AnnouncementBellController from "./announcement_bell_controller"
application.register("announcement-bell", AnnouncementBellController)

import OrgSwitcherController from "./org_switcher_controller"
application.register("org-switcher", OrgSwitcherController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)

import WhatsappWindowCountdownController from "./whatsapp_window_countdown_controller"
application.register("whatsapp-window-countdown", WhatsappWindowCountdownController)

import WhatsappTemplateParamsController from "./whatsapp_template_params_controller"
application.register("whatsapp-template-params", WhatsappTemplateParamsController)

import WhatsappInboxController from "./whatsapp_inbox_controller"
application.register("whatsapp-inbox", WhatsappInboxController)

import WhatsappMediaComposerController from "./whatsapp_media_composer_controller"
application.register("whatsapp-media-composer", WhatsappMediaComposerController)

import WhatsappLightboxController from "./whatsapp_lightbox_controller"
application.register("whatsapp-lightbox", WhatsappLightboxController)

import WhatsappThreadScrollController from "./whatsapp_thread_scroll_controller"
application.register("whatsapp-thread-scroll", WhatsappThreadScrollController)

import WhatsappBroadcastScheduleController from "./whatsapp_broadcast_schedule_controller"
application.register("whatsapp-broadcast-schedule", WhatsappBroadcastScheduleController)

import PreattendanceBotEditorController from "./preattendance_bot_editor_controller"
application.register("preattendance-bot-editor", PreattendanceBotEditorController)

import WhatsappTemplateFormController from "./whatsapp_template_form_controller"
application.register("whatsapp-template-form", WhatsappTemplateFormController)
